/* eslint-disable react/require-default-props */
/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';

import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';

import GeneralTitle from 'settings/page-elements/GeneralTitle';
import { getQRData } from 'stocks/actions';
import HeaderStocksNavigation from 'stocks/components/HeaderStocksNavigation';

class StockTakeLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    this.props.getQRData();
  }

  render() {
    const { salonId, history, tokenData, salonName, t } = this.props;

    return (
      <div>
        <HeaderStocksNavigation salonId={salonId} history={history} PageTitle="Stock Management" />
        <div className="qr-code-layout">
          <GeneralTitle generalTitle={t('stocks.syncScanner.title')} subTitle={t('stocks.syncScanner.subTitle')} />
          <p>
            {t('stocks.syncScanner.bullet1Part1')}
            <a
              href="https://itunes.apple.com/gb/app/slick-stock-management/id1438551651?mt=8"
              target="_blank"
              rel="noopener noreferrer"
            >
              {S.space}
              {t('stocks.syncScanner.bullet1Part2')}
              {S.space}
            </a>
            {t('stocks.syncScanner.bullet1Part3')}
          </p>
          <p>{t('stocks.syncScanner.bullet2')}</p>
          {/* (for download instructions click here) */}
          <p>{t('stocks.syncScanner.bullet3')}</p>
          <div className="qr-container">
            <header>{t('stocks.syncScanner.scanButton')}</header>
            <div className="code">
              {tokenData && (
                <QRCode
                  size={400}
                  value={JSON.stringify({
                    ...tokenData,
                    salonId,
                    salonName,
                  })}
                />
              )}
            </div>
            {/* <div>
              To track stock please contact your account manager to be part of our beta test programme
              <br />
              Each user who wants to scan stock will need an iPhone
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, name: salonName },
    stockManagement: {
      auth: { errorMessage, isFetching, tokenData },
    },
  } = state;
  return {
    salonId,
    errorMessage,
    isFetching,
    tokenData,
    salonName,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    getQRData() {
      dispatch(getQRData());
    },
  };
}

const StockTakeLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StockTakeLayout));
export default StockTakeLayoutHoc;
